import * as React from "react"
import { Eye, EyeOff } from "lucide-react"
import { cn } from "../../lib/utils";

const Password = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
  const [inputType, setInputType] = React.useState(type);

  const toggleInputType = () => {
    setInputType(inputType === 'password' ? 'text' : 'password')
  }

    return (<span className={cn("flex items-center gap-2", className)}>
      <input
        type={inputType}
        className={cn(
          "flex-1 flex h-9 w-full outline-none border-none bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        )}
        ref={ref}
        {...props}
      />
      {inputType === 'password'
      ? <EyeOff size={20} className="cursor-pointer mr-3" onClick={toggleInputType} />
      : <Eye size={20} className="cursor-pointer mr-3" onClick={toggleInputType} /> }
    </span>
    );
  }
);
Password.displayName = "Password";

export { Password };